import photo1 from './project18-1.png';
import photo2 from './project18-2.png';
import photo3 from './project18-3.png';
import photo4 from './project18-4.png';
import photo5 from './project18-5.png';
import photo6 from './project18-6.png';
import photo7 from './project18-7.png';
import photo8 from './project18-8.png';

const project18 = {
  id: 18,
  name: 'SongPin',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '김민용 최영서 이가빈 최윤진',
    },
    {
      position: 'BackEnd Developer',
      names: '이서현 정유정 문하영 황채린',
    },
    {
      position: 'UXUI Designer',
      names: '이채연',
    },
  ],
  about:
    "장소에는 기억과 소리가 담깁니다. 여러분이 언젠가 여행을 떠났을 때 들었던 음악을 기억하나요? 여행지에서 많이 들은 음악은 곧, 그 장소의 분위기를 상징하고 기억할 수 있는 추억을 지닌 음악이 됩니다. 여행이 끝나도 사람들은 그 음악을 들으면서 행복했던 여행의 순간들을 생생하게 회상합니다. 이러한 아이디어에서 'SongPin' 프로젝트가 탄생했습니다.",
  links: {
    website: 'https://songpin.vercel.app/',
    github: 'https://github.com/EFUB4-Jukebox',
  },
  photos: [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8],
};

export default project18;
